import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import Tile from "./Tile";
import { drawTileToAI, aiMakesMove } from "../redux/dominoSlice";
import { StockContainer, Title, SubTitle as ST } from "./styled";
import { Wrapper } from "./styled/StockContainer";
import { localizations, getLanguage } from "./localization";

const SubTitle = styled(ST)`
  margin-bottom: 0rem;
`;
const AIPlayer = () => {
  const dispatch = useDispatch();
  const {
    players: [, aiPlayer],
    winner,
  } = useSelector((state) => state.domino);

  const delay = 600;

  useEffect(() => {
    if (aiPlayer?.missedLastMove > 0 && !winner) {
      setTimeout(() => {
        dispatch(drawTileToAI());
        dispatch(aiMakesMove());
      }, delay);
    }
  }, [aiPlayer?.missedLastMove, winner]);
  return (
    <>
      {aiPlayer?.stock?.length > 0 ? (
        <>
          <Title>{`${localizations.player[getLanguage()]}: ${
            aiPlayer?.name
          }`}</Title>
          <Wrapper>
            <StockContainer>
              {aiPlayer?.stock?.map((tile) => (
                <Tile key={tile.id} tile={tile} variant="dimmed" faceDown />
              ))}
            </StockContainer>
          </Wrapper>
        </>
      ) : (
        <>
          <Title>{localizations.opponentStocks[getLanguage()]}</Title>
          <SubTitle>{localizations.empty[getLanguage()]}</SubTitle>
        </>
      )}
    </>
  );
};

export default AIPlayer;
